

import { Component, Vue } from 'vue-property-decorator'
import PublicTable from '@/components/PublicTable/PublicTable.vue'
import PublicTableView from '@/components/PublicTable/PublicTableView'
import { ICol } from '@/components/PublicTable/PublicTable'
import api from '../../api'
import { UserModule } from '../../store/modules/user'
import CreateManualFailure from '@/components/Dialog/CreateManualFailure.vue'

@Component({
  components: {
    PublicTable,
    CreateManualFailure,
  },
})
export default class StatsExcaption extends PublicTableView {
  private selection: any[] = []
  protected columns: ICol[] = [
    { label: '上报时间', prop: 'gmtCreate' },
    // { label: '栋', prop: 'name' },
    // { label: '层', prop: 'name' },
    // { label: '区', prop: 'name' },
    { label: '网络', prop: 'aliasName' },
    { label: '设备ID', prop: 'devId' },
    { label: '故障', prop: 'content', width: '250', type: 'custom' },
    { label: '解决状态', prop: 'show', type: 'custom' },
  ]
  public mounted() {
    this.onQuery(1)
  }
  private onCreateManualFailure() {
    (this.$refs.CreateManualFailure as CreateManualFailure).show()
  }
  private deleteDevExcaptions() {
    if (this.selection.length === 0) {
      this.$message.warning('请选择需要修改的记录')
      return
    }
    this.$confirm('修改当前选中记录状态, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      api.deleteDevExcaptions({ devFaultCleanList: this.selection }).then(() => {
        this.$message.success('清除成功')
        this.onQuery({ isUseCache: false, pageNum: 1 })
      })
    }).catch(() => {})
  }
  private rowClick(row: any) {
    (this.$refs.publicTable as PublicTable).tableNode.toggleRowSelection(row)
  }
  private selectionChange(selection: any) {
    this.selection = selection || []
  }
  protected queryMethod = api.getDevExcaptionList
  protected queryParams = {
    arg1: UserModule.orgInfo.orgId,
  }
  protected processData(payload: any) {
    const { content = [], totalSize = 0 } = payload || {}
    this.pageData.pageCount = totalSize
    return content
  }
}
